// ----------------email regex---------------------
export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
// -----------------mobile number regex---------------
export function validatePhoneNumber(input_str,cntryCode) {
  // var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  if(cntryCode === 'ARE'){
    var re = /^([+]\d{2}[ ])?\d{9}$/;
  }
  else{
     re = /^([+]\d{2}[ ])?\d{10}$/;
  } 
  return re.test(input_str);
}
// -------------------valid name regex-----------------
export function validatename(input_str) {
  var re = /^[a-zA-Z][a-zA-Z ]*$/;
  return re.test(input_str);
}
export function validateOnlyNumbers(str) {
  return /^\d+$/.test(str);
}
export function validatePassword(password) {
  // Regular expression for password validation
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!?&])[A-Za-z\d@$!?&]{8,}$/;

  // Check the primary password pattern
  if (!passwordRegex.test(password)) {
      return { valid: false, error: "Password must be at least 8 characters long, include at least one uppercase letter, one lowercase letter, one number, and one special character (@$!?&)." };
  }

  // Convert password to lowercase for case-insensitive checking
  const lowerPassword = password.toLowerCase();

  // Define forbidden sequential patterns
  const sequentialPatterns = [
      "0123456789", "9876543210", // Sequential and reverse sequential numbers
      "abcdefghijklmnopqrstuvwxyz", "zyxwvutsrqponmlkjihgfedcba" // Alphabet sequences
  ];

  // Check for sequential patterns (3+ characters)
  for (const seq of sequentialPatterns) {
      for (let i = 0; i < seq.length - 2; i++) {
          const subseq = seq.substring(i, i + 3);
          if (lowerPassword.includes(subseq)) {
              return { valid: false, error: "Password should not contain sequential patterns like '123' or 'abc'." };
          }
      }
  }

  // Check for more than two repeated characters
  if (/(\w)\1{2,}/.test(password)) { // Matches aaa, 111, etc.
      return { valid: false, error: "Password should not contain more than two repeated characters in a row." };
  }

  return { valid: true, error: "" }; // Password is valid
}

export function validateAmount(value) {
  // Regular expression for validating amount:
  // - Starts with optional digits (can be zero)
  // - Followed by an optional decimal point and up to 3 decimal places
  const amountRegex = /^(0|[1-9]\d*)(\.\d{1,3})?$/;
  return amountRegex.test(value);
}

export const roundTo2Decimals = (value) => {
  return Number(parseFloat(value).toFixed(2));
};